import { FtthOrder } from '@features/siteStatusV2/types';
import React from 'react';

import OrderDetails from '../order-details';
import { createFtthDisplayConfig } from './helpers';

interface FtthOrderDetailsProps {
  order: FtthOrder;
}

const FtthOrderDetails: React.FC<FtthOrderDetailsProps> = ({ order }) => {
  const ftthDisplayConfig = createFtthDisplayConfig(order);
  return <OrderDetails header={ftthDisplayConfig.header} sections={ftthDisplayConfig.sections} />;
};

export default FtthOrderDetails;
